export enum DisplayOption  {
    TEXT,
    TEXT_LINK,
    OPTION,
    IMAGE,
    SUGGESTION,
    CARD,
    CARD_CAROUSEL,
    UNDEFINED
}
// interface  DialogNode{
//     dialogNode: string
// }

export interface TextResponse {
    text: string;
}

export interface TextLinkResponse {
    text: string;
}

export interface OptionResponse {
    title: string;
    description?: string;
    options: Option[];
}

export interface ImageResponse {
    source: string;
}

export interface CardResponse {
    title: string;
    description: string;
    media: ImageResponse;
    actions: Option[];
}

export interface CardCarouselResponse {
    cards: CardResponse[];
}

export interface Option {
    label: string;
    value: string;
    isNew: boolean;
}

export default interface Conversation {
    context?: any;
    genericResponses?: GenericResponse[];
}

export class GenericResponse {
    responseType: string;
    response: any;

    constructor(response:any) {
        this.response = response;
        this.responseType = response.response_type;
    }

    parseTextResponse() {
        this.response =  {text: this.response.text} as TextResponse;
    }

    parseTextLinkResponse() {
        this.response =  {text: this.response.text} as TextLinkResponse;
    }

    parseOptionResponse(context:any) {
        this.response =  {title: this.response.title, description: this.response.description, options: this.parseOptions(this.response.options, context) } as OptionResponse;
    }

    parseOptions(options: any, context: any): Option[] {
        return options.map((option: any)=>{
            let optIsNew = false;
            if(context.newBadge){
                context.newBadge.map((bObj:any) => {
                    switch(bObj.field_type){
                        case "value":
                            if(option.value === bObj.match_string){
                                optIsNew = true;
                            }
                            break;
                        case "label":default:
                            if(option.label === bObj.match_string){
                                optIsNew = true;
                            }
                            break;
                    }
                    return null;
                });
            }        
            return {label: option.label, value: option.value.input.text, isNew: optIsNew}
        })
    }

    parseImageResponse() {
        this.response = {source: this.response.source} as ImageResponse;
    }
}